module.exports = __webpack_public_path__ + "media/images/lb/936-d7c8bdd0fe9e22597196ebd49ee43f24.svg";